import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 22,
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: "linear-gradient( 95deg,rgb(41, 125, 234) 0%,rgb(16, 79, 162) 50%,rgb(5, 23, 46) 100%)",
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			backgroundImage: "linear-gradient( 95deg,rgb(41, 125, 234) 0%,rgb(16, 79, 162) 50%,rgb(5, 23, 46) 100%)",
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		height: 3,
		border: 0,
		backgroundColor: "#eaeaf0",
		borderRadius: 1,

		...theme.applyStyles("dark", {
			backgroundColor: theme.palette.grey[800],
		}),
	},
}));

const ColorlibStepIconRoot = styled("div")(({ theme }) => ({
	backgroundColor: "#ccc",
	zIndex: 1,
	color: "#fff",
	width: 50,
	height: 50,
	display: "flex",
	borderRadius: "50%",
	justifyContent: "center",
	alignItems: "center",

	...theme.applyStyles("dark", {
		backgroundColor: theme.palette.grey[700],
	}),

	variants: [
		{
			// @ts-ignore
			props: ({ ownerState }) => ownerState.active,

			style: {
				backgroundImage: "linear-gradient( 136deg, rgb(41, 125, 234) 0%, rgb(16, 79, 162) 50%, rgb(5, 23, 46) 100%)",
				boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
			},
		},
		{
			// @ts-ignore
			props: ({ ownerState }) => ownerState.completed,

			style: {
				backgroundImage: "linear-gradient( 136deg, rgb(41, 125, 234) 0%, rgb(16, 79, 162) 50%, rgb(5, 23, 46) 100%)",
			},
		},
	],
}));

/**
 * @param {Object} props
 * @param {boolean} [props.active=false] Whether this step is active.
 * @param {boolean} [props.completed=false] Mark the step as completed. Is passed to child components.
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.icon] The label displayed in the step icon.
 */
function ColorlibStepIcon(props) {
	const { active, completed, className, icon } = props;

	return (
		<ColorlibStepIconRoot
			// @ts-ignore
			ownerState={{ completed, active }}
			className={className}
		>
			{icon}
		</ColorlibStepIconRoot>
	);
}

export default function SaitSteppers(props) {
	return (
		<Stack sx={{ width: "100%" }} spacing={4}>
			<Stepper alternativeLabel activeStep={props.activePage} connector={<ColorlibConnector />}>
				{props.pages.map((page, index) => (
					<Step key={index}>
						<StepLabel
							icon={page.stepper ? page.stepper.icon : <Fragment />}
							slots={{
								stepIcon: ColorlibStepIcon,
							}}
						>
							{page.stepper ? page.stepper.label : ""}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</Stack>
	);
}
